import { skipToken } from "@reduxjs/toolkit/query/react";
import useRegistrationGate from "./useRegistrationGate";
import api from "../api/api";
import { useGetConversationQuery } from "../api/helpers";
import useAuth from "../auth/useAuth";
import useVenueId from "../common/useVenueId";

const useLoadedData = () => {
  const venueId = useVenueId();
  const isAuthed = useAuth();

  useGetConversationQuery();

  api.useGetTenantQuery(skipToken);

  const { isError: isTenantError, isSuccess: isTenantSuccess } =
    api.useGetTenantQuery(isAuthed || skipToken);
  const { isError: isUserError, isSuccess: isUserSuccess } =
    api.useGetUserQuery(isAuthed || skipToken);
  const { isError: isVenueError, isSuccess: isVenueSuccess } =
    api.useGetVenueQuery(isAuthed ? venueId : skipToken);
  const { isError: isSessionsError, isSuccess: isSessionsSuccess } =
    api.useGetSessionsQuery(isAuthed ? venueId : skipToken);
  const { isSuccess: isRegistrationSuccess, data } = useRegistrationGate();

  const isError =
    isTenantError || isUserError || isVenueError || isSessionsError;

  const isSuccess =
    isTenantSuccess &&
    isUserSuccess &&
    isVenueSuccess &&
    isSessionsSuccess &&
    isRegistrationSuccess &&
    data?.isRegistered === true;

  return {
    isError,
    isSuccess,
  };
};

export default useLoadedData;
